import { render, staticRenderFns } from "./ItemAuthorActionsBanks.vue?vue&type=template&id=27d90644"
import script from "./ItemAuthorActionsBanks.vue?vue&type=script&lang=js"
export * from "./ItemAuthorActionsBanks.vue?vue&type=script&lang=js"
import style0 from "./ItemAuthorActionsBanks.vue?vue&type=style&index=0&id=27d90644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports